import { useNuxtApp } from '#app'

export default defineNuxtRouteMiddleware((to, from) => {
    // Define routes where loader should be skipped
    const noLoaderRoutes = ['/', '/login']

    if (noLoaderRoutes.includes(to.path)) {
        return // Skip loader
    }

    const { startFetch, endFetch } = usePageLoading()
    
    // Start loader
    startFetch()

    // Fallback to stop loader after 1 second
    setTimeout(() => {
        endFetch()
    }, 1000)
})  